import React from 'react'

function Snap() {
  return (
    <>
      <div className='container py-5'>
      <div className='row justify-content-center'>
            <div className='col-lg-8'>
            <div className='popular py-5 text-center'>
          <p className='fs-6 fw-semibold text-secondary best'>IMAGE GALLERY</p>
          <h2 className='fs-1 fw-bold py-2'>Our Recent Snaps</h2>
          <p className='fs-6 fw-normal'>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Morbi posuere tempor mauris, nec
             imperdiet mi rutrum eget. Donec quis ligula in tellus dictum consequat.</p>
          </div>
            </div>
        </div>
        <div className='row pt-5'>
            <div className='col-lg-4'>
               <img className='w-100' src={require('../image/g1.jpg')}/>
               <img className='w-100 mt-2' src={require('../image/g31.jpg')}/>
               <img className='w-100 mt-2' src={require('../image/traveler1.jpg')}/>
            </div>
            <div className='col-lg-4'>
               <img className='w-100' src={require('../image/g21.jpg')}/>
               <img className='w-100 mt-2' height={412} src={require('../image/region3.jpg')}/>
            </div>
            <div className='col-lg-4'>
               <img className='w-100' src={require('../image/g4.jpg')}/>
               <img className='w-100 mt-2' height={256} src={require('../image/g5.jpg')}/>
            </div>
        </div>
      </div>
      <div className='dest2 mt-5'>
    <div className='container py-5'>
        <div className='row'>
          <div className='col-lg-7'>
          <div className='popular pt-2 text-start'>
          <p className='fs-6 fw-semibold text-secondary best'>RICH OUT NOW</p>
          <h2 className='fs-1 fw-bold py-3' >We’re available for 8 hours a day! Contact to require a detailed analysis and assessment of your plan.</h2>
          <p className='fs-6 fw-semibold'>Lorem Ipsum is simply dummy text of the printing and typesetting industry has been the industry’s standard dummy text ever since the when an unknown printer took a galley.</p>
          </div>
       </div>
       <div className='col-lg-5'>
          <div className='popular py-5 text-center ms-3 float-end'>
          <i class="bi bi-telephone-outbound pb-3"></i>
          <h1 className=' fw-bold py-3 day' >+99 456 457 000</h1>
          <button type="button" class="btn btn-lg px-5 py-3 contact">
              Contact Us
            </button>
          </div>
       </div>
        </div>
    </div>
    </div>
    </>
  )
}

export default Snap
